// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- ambient 宣言は import できない（下記）
/// <reference path="./env.d.ts" />
// 環境設定（環境差分は env のみ＝02 §5）。
// dev は Vite の proxy で同一オリジン（/api → localhost:8000）。stg/prod は api. の絶対URL。
//
// ※ 参照を triple-slash で書くのは、このパッケージを**ソースのまま**取り込む側
//   （api-client・各 app）でも env.d.ts が効くようにするため（include だけだと伝播しない）。

export const config = {
  /** API のベース。dev は "" ＝同一オリジン（Vite proxy 経由）。 */
  apiBase: import.meta.env?.VITE_API_BASE ?? "",
  /** CSRF 用のカスタムヘッダ名（02 §4.2・backend の csrf_header_name と一致させる）。 */
  csrfHeader: "X-KZ-CSRF",
  /** LIFF ID（06 §9）。M1 で実値（H6）。未設定なら開発モックへ落とす。 */
  liffId: import.meta.env?.VITE_LIFF_ID ?? "",
} as const;
